import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
